import { wirelessBreadcrumbsConfig } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.config';
import { RouteBreadcrumbsConfig } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.model';

const breadcrumbsManagePlan = 'manage-plan.header';

const managePlanBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [
    wirelessBreadcrumbsConfig,
    {
      alt: '',
      copy: breadcrumbsManagePlan,
      val: null,
    },
  ],
  useRegEx: true,
  regexp: /(^manage-plan)/,
};

export const managePlanBreadcrumbsConfigs: RouteBreadcrumbsConfig[] = [managePlanBreadcrumbsConfig];
